import React from 'react';

import { Money, formatMoney } from '@betterment/core';
import { Box, Card, H2, Separator, Text } from '@betterment/samba-react';

import { trackClick } from '../../../../features/track';
import { TaxLossHarvestingPerformanceModal } from '../../../../Shared/components-v2/tax-loss-harvesting/TaxLossHarvestingPerformanceModal';
import { TaxLossHarvestingToggletip } from '../../../../Shared/components-v2/tax-loss-harvesting/TaxLossHarvestingToggletip';

interface Props {
  allTimeTaxSavings?: Money;
  taxLossesHarvested?: Money;
}

export const TaxSavingsEnabledCard: React.FC<Props> = ({ allTimeTaxSavings, taxLossesHarvested }) => {
  const handleSeeDetailsClick = () => {
    trackClick({
      name: 'tlhActiveSeeDetails',
      module: 'Performance',
      location: 'TaxSavingsCard',
    });
  };

  const handleHarvestedLossesToolTipOpen = (open: boolean) => {
    if (open) {
      trackClick({
        name: 'harvestedLossesToolTip',
        module: 'Performance',
        location: 'TaxSavingsCard',
      });
    }
  };

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <H2 variant="title200">Tax savings</H2>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300', display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        {allTimeTaxSavings && (
          <Box css={{ display: 'flex', flexDirection: 'column' }}>
            <Text>Estimated taxes saved</Text>
            <Text variant="text300" css={{ color: 'text.success' }}>
              {formatMoney(allTimeTaxSavings)}
            </Text>
          </Box>
        )}
        {taxLossesHarvested && (
          <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>
              Tax losses harvested
              <TaxLossHarvestingToggletip isEnabled={true} onOpenChange={handleHarvestedLossesToolTipOpen} />
            </Text>
            <Text>{formatMoney(taxLossesHarvested)}</Text>
          </Box>
        )}
        {!allTimeTaxSavings && (
          <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>
              Tax losses harvesting
              <TaxLossHarvestingToggletip isEnabled={true} onOpenChange={handleHarvestedLossesToolTipOpen} />
            </Text>
            <Text>Active</Text>
          </Box>
        )}
      </Card.Content>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Footer css={{ padding: 'space.300' }}>
        <TaxLossHarvestingPerformanceModal onOpenClick={handleSeeDetailsClick} />
      </Card.Footer>
    </Card>
  );
};
